import { signal } from '@angular/core';
import { Diagnosis } from 'src/app/components/diagnosis/diagnosis.service';

interface Choice {
  label: string;
  value: number;
}

export interface Question {
  index: number;
  name: 'step1' | 'step2' | 'step3' | 'step4' | 'step5' | 'step6';
  title: string,
  imgSrc: string,
  choices: Choice[]
}

export function createDiagnosisForm() {
  const questions: Question[] = [
    {
      index: 1,
      name: 'step1',
      title: '現在の年齢',
      imgSrc: 'https://file.mysquadbeyond.com/uploads/article_photo/photo/5330376/f3f8e81a-10ca-4369-b18b-6e8a0156fbf1.png',
      choices: [
        { label: '15歳~18歳', value: 1 },
        { label: '19歳~22歳', value: 2 },
        { label: '23歳~30歳', value: 3 }
      ]
    },
    {
      index: 2,
      name: 'step2',
      title: '現在の職業',
      imgSrc: 'https://file.mysquadbeyond.com/uploads/article_photo/photo/5330404/94d6ab5d-e3ec-42b8-8c30-0256a15818de.png',
      choices: [
        { label: '社会人', value: 1 },
        { label: '学生', value: 2 },
        { label: '主婦(夫)', value: 3 },
        { label: 'その他', value: 4 },
      ]
    },
    {
      index: 3,
      name: 'step3',
      title: '現在の英語力',
      imgSrc: 'https://file.mysquadbeyond.com/uploads/article_photo/photo/5330377/f01981b1-7d6f-41f3-acd2-cd99cc6969c8.png',
      choices: [
        { label: '話せず聞き取れない', value: 1 },
        { label: '一部話せて聞き取れる', value: 2 },
        { label: '日常会話ができる', value: 3 },
        { label: 'ビジネス会話ができる', value: 4 },
      ]
    },
    {
      index: 4,
      name: 'step4',
      title: '留学で身につけたい英語力',
      imgSrc: 'https://file.mysquadbeyond.com/uploads/article_photo/photo/5330371/2f9a0863-98b7-40cf-8901-eae98b408e13.png',
      choices: [
        { label: '旅行に困らない', value: 1 },
        { label: 'スムーズな日常会話', value: 2 },
        { label: '接客やバイトで使える', value: 3 },
        { label: 'ビジネス英語', value: 4 },
        { label: 'ネイティブと同等', value: 5 },
      ]
    },
    {
      index: 5,
      name: 'step5',
      title: '英語以外で留学に最も期待すること',
      imgSrc: 'https://file.mysquadbeyond.com/uploads/article_photo/photo/5330378/613aa1c1-7c72-43cd-b7d4-9e33484e5232.png',
      choices: [
        { label: '自己成長・自信をつける', value: 1 },
        { label: 'キャリアアップ・転職', value: 2 },
        { label: '外国人の友達ができる', value: 3 },
        { label: 'お金を稼ぎたい', value: 4 },
        { label: '自由なライフスタイル', value: 5 },
      ]
    },
    {
      index: 6,
      name: 'step6',
      title: '予算',
      imgSrc: 'https://file.mysquadbeyond.com/uploads/article_photo/photo/5330381/e14bdd09-0057-4d2c-9e91-4adf9b1096a5.png',
      choices: [
        { label: '30万円未満', value: 1 },
        { label: '30万〜50万円未満', value: 2 },
        { label: '50万〜100万円未満', value: 3 },
        { label: '100万円以上', value: 4 },
      ]
    }
  ];
  const form = {
    step1: signal<number>(0),
    step2: signal<number>(0),
    step3: signal<number>(0),
    step4: signal<number>(0),
    step5: signal<number>(0),
    step6: signal<number>(0)
  };
  return {
    ...form,
    get questions() {
      return questions;
    },
    get formValue() {
      return {
        step1: form.step1(),
        step2: form.step2(),
        step3: form.step3(),
        step4: form.step4(),
        step5: form.step5(),
        step6: form.step6()
      } as Diagnosis;
    }
  }
;
}
